<app-spinner [loading]="load"></app-spinner>
<div class="form-group">
  <mat-form-field appearance="fill" class="w-100">
    <mat-label>მშობელი მენიუ</mat-label>
    <input
      type="text"
      matInput
      [formControl]="searchControl"
      [matAutocomplete]="auto"
      class="form-control"
      placeholder="მოძებნე მშობელი მენიუ"
      (click)="onInputClick()"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayFn"
      (optionSelected)="onSelect($event.option.value)"
    >
      <mat-option [value]="{ id: 0, menutitle: '' }">აირჩიე მშობელი მენიუ</mat-option>
      <mat-option *ngFor="let page of filteredPages" [value]="page">
        <span [style.padding-left.px]="page.depth * 20">
          {{ page.title }}
        </span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
